<template>
  <div>
    <div ref="component" class="simple cx_style" :class="'imgCrop_' + request_prefix">
      <div class="content">
        <div class="content-item mb16 verticallyCenter">
          <div class="fs14 mr16">
            缩放<i class="tips-btn icon-portal-info2" @click.stop.prevent="explainDialogClick(1)"></i>
          </div>
          <div class="font-arrangement-btn">
            <span class="btn-active" :style="getTranslate"></span>
            <span
              v-for="(option, index) in clipSizeList"
              :key="index"
              class="fs13"
              :class="clipSizeVal == option.label ? 'select pd2' : 'pd2'"
              @click="changeClipSize(option.label)"
              >{{ option.title }}</span
            >
          </div>
        </div>
      </div>
      <div class="content-item mb16 verticallyCenter">
        <div class="fs14 mr16">平铺<i class="tips-btn icon-portal-info2" @click.stop.prevent="explainDialogClick(2)"></i></div>
        <div class="font-arrangement-btn">
          <span class="btn-active" :style="getTranslate1"></span>
          <el-tooltip
            v-for="(val, index) in repeatTypeList"
            :key="index"
            class="item"
            effect="dark"
            :content="val.title"
            placement="top-end"
            :open-delay="1000"
          >
            <span
              :key="index"
              :class="repeatTypeVal == val.label ? 'select pd2' : 'pd2'"
              @click="changeRepeatType(val.label)"
              ><i :class="val.className"></i
            ></span>
          </el-tooltip>
        </div>
      </div>
      <div class="content-item verticallyCenter">
        <div class="fs14 mr16">对齐</div>
        <ul class="align-style-ul">
          <li
            v-for="(item, index) in alignTypeList"
            :key="index"
            :class="alignTypeVal == item ? 'selected' : ''"
            @click="changeAlignType(item)"
          ></li>
        </ul>
      </div>
    </div>
    <el-dialog title="说明" :append-to-body="true" :visible.sync="explainDialog" custom-class="explainDialog">
      <p class="fs14 tips" v-for="(item, index) in explainTextList" :key="index">
        <span>{{ item.explainTitle }}</span
        >{{ item.explainTips }}
      </p>
      <div class="box">
        <img :src="explainImgSrc" v-if="explainImgSrc" alt="" class="img" />
        <video :src="explainVideoSrc" controls v-if="explainVideoSrc"></video>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import "../common.css"
import defaultImgSrc from "../../assets/images/default_image.png"
import publicData from "../mixins/publicData.js"
import { uploadResources } from "../../utils"
export default {
  mixins: [publicData],
  name: "imgCrop",
  props: {
    clipSize: {
      type: String,
      required: true
    },
    repeatType: {
      type: String,
      required: false
    },
    alignType: {
      type: String,
      required: false
    },
    themeKey: {
      type: String,
      default: "",
      required: false
    }
  },
  data() {
    return {
      clipSizeList: [
        {
          label: "auto auto",
          title: "原始"
        },
        {
          label: "cover",
          title: "填充"
        },
        {
          label: "auto 100%",
          title: "适应"
        },
        {
          label: "100% 100%",
          title: "拉伸"
        }
      ],
      repeatTypeList: [
        {
          className: "icon-portal-none",
          label: "no-repeat",
          title: "不平铺"
        },
        {
          className: "icon-portal-tile-xy",
          label: "repeat",
          title: "双向平铺"
        },
        {
          className: "icon-portal-tile-x",
          label: "repeat-x",
          title: "横向平铺"
        },
        {
          className: "icon-portal-tile-y",
          label: "repeat-y",
          title: "纵向平铺"
        }
      ],
      alignTypeList: [
        "left top",
        "center top",
        "right top",
        "left center",
        "center center",
        "right center",
        "left bottom",
        "center bottom",
        "right bottom"
      ],
      translate: 0,
      translate1: 0,
      explainDialog: false,
      explainTextList: [],
      explainImgSrc: "",
      explainVideoSrc: "",
      sliderWidth: 0
    }
  },
  computed: {
    clipSizeVal: {
      get() {
        let index = this.clipSizeList.findIndex(item => item.label === this.clipSize)
        this.translate = this.sliderWidth * index
        return this.clipSize
      },
      set(val) {
        this.$emit("update:clipSize", val)
      }
    },
    getTranslate() {
      return {
        transform: `translateX(${this.translate}px)`
      }
    },
    repeatTypeVal: {
      get() {
        let index = this.repeatTypeList.findIndex(item => item.label === this.repeatType)
        this.translate1 = this.sliderWidth * index
        return this.repeatType
      },
      set(val) {
        this.$emit("update:repeatType", val)
      }
    },
    getTranslate1() {
      return {
        transform: `translateX(${this.translate1}px)`
      }
    },
    alignTypeVal: {
      get() {
        return this.alignType
      },
      set(val) {
        this.$emit("update:alignType", val)
      }
    }
  },
  mounted() {
    const width = this.$refs.component.querySelector(".font-arrangement-btn").clientWidth
    this.sliderWidth = parseInt((width - 6) / this.clipSizeList.length || 0)
  },
  methods: {
    explainDialogClick(type) {
      this.explainDialog = true
      switch (type) {
        case 1:
          this.explainTextList = [
            {
              explainTitle: "原始效果：",
              explainTips: "图片不跟随容器缩放，保持原尺寸。"
            },
            {
              explainTitle: "填充效果：",
              explainTips: "图片跟随容器宽高等比缩放，超出容器的部分会被裁切。"
            },
            {
              explainTitle: "适应效果：",
              explainTips: "图片跟随容器宽高等比缩放，始终在容器内完整显示。"
            },
            {
              explainTitle: "拉伸效果：",
              explainTips: "图片的宽高跟随容器宽高拉伸，始终充满容器。"
            }
          ]
          this.explainImgSrc = require("../../assets/images/tipsVideoImg/img-crop1.png")
          break
        case 2:
          this.explainTextList = [
            {
              explainTitle: "",
              explainTips: "只有当图片的缩放设置为“原始”，且原始图片尺寸小于容器尺寸时才生效。"
            },
            {
              explainTitle: "不平铺：",
              explainTips: "图片根据“对齐”设置的位置进行显示。"
            },
            {
              explainTitle: "双向平铺：",
              explainTips: "图片根据“对齐”设置的位置为起点，在横向和纵向2个方向上重复平铺，直到铺满整个容器。"
            },
            {
              explainTitle: "横向平铺：",
              explainTips: "图片根据“对齐”设置的位置为起点，在横向的方向上重复平铺，直到铺满容器的宽度。"
            },
            {
              explainTitle: "纵向平铺：",
              explainTips: "图片根据'对齐'设置的位置为起点，在纵向的方向上重复平铺，直到铺满容器的高度。"
            }
          ]
          this.explainImgSrc = require("../../assets/images/tipsVideoImg/img-crop2.png")
          break
      }
    },
    changeRepeatType(value) {
      this.repeatTypeVal = value
    },
    changeAlignType(value) {
      this.alignTypeVal = value
    },
    changeClipSize(val) {
      this.clipSizeVal = val
    }
  }
}
</script>

<style scoped>
/**
平铺样式
 */
.repeat-style-ul {
  font-size: 0;
}

.repeat-style-ul > li {
  display: inline-block;
  text-align: center;
  font-size: 14px;
  cursor: pointer;
  margin-right: 24px;
  margin-bottom: 16px;
}
.repeat-style-ul > li .rs-style-wrap {
  position: relative;
}

.repeat-style-ul > li .rs-style {
  display: inline-block;
  width: 60px;
  height: 60px;
  margin-bottom: 8px;
  background: var(--inputBackGround);
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 3px;
}

.repeat-style-ul > li .rs-style span {
  position: relative;
  display: block;
  width: 9px;
  height: 9px;
  opacity: 0.5;
  background: var(--themeColor);
  border-radius: 1px;
  margin-top: 1px;
}

.repeat-style-ul > li .rs-style.selected {
  -webkit-box-shadow: none;
  box-shadow: none;
  border: 2px solid var(--themeColor);
}

.repeat-style-ul > li .rs-style.selected span {
  opacity: 1;
}

.repeat-style-ul > li .rs-box {
  display: inline-block;
}

.repeat-style-ul > li:first-child .rs-style span:nth-of-type(n + 2) {
  display: none;
}

.repeat-style-ul > li:first-child .rs-style span {
  width: 3px;
  height: 36px;
  margin-top: 12px;
  transform: rotate(-45deg);
}

.repeat-style-ul > li:nth-child(2) .rs-box {
  margin-top: 12px;
}

.repeat-style-ul > li:nth-child(2) .rs-style span:after {
  position: absolute;
  top: 0;
  right: -12px;
  display: inline-block;
  content: "";
  width: 9px;
  height: 9px;
  opacity: 1;
  background: inherit;
  border-radius: 1px;
}

.repeat-style-ul > li:nth-child(2) .rs-style span:before {
  position: absolute;
  top: 0;
  left: -12px;
  display: inline-block;
  content: "";
  width: 9px;
  height: 9px;
  opacity: 1;
  background: inherit;
  border-radius: 1px;
}

.repeat-style-ul > li:nth-child(3) .rs-box {
  margin-left: -12px;
  margin-top: 12px;
}

.repeat-style-ul > li:nth-child(3) .rs-style {
  -webkit-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  transform: rotate(90deg);
}

.repeat-style-ul > li:nth-child(3) .rs-style span:after {
  position: absolute;
  top: 0;
  right: -12px;
  display: inline-block;
  content: "";
  width: 9px;
  height: 9px;
  opacity: 1;
  background: inherit;
  border-radius: 1px;
}

.repeat-style-ul > li:nth-child(4) .rs-box {
  margin-left: -12px;
  margin-top: 12px;
}

.repeat-style-ul > li:nth-child(4) .rs-style span:after {
  position: absolute;
  top: 0;
  right: -12px;
  display: inline-block;
  content: "";
  width: 9px;
  height: 9px;
  opacity: 1;
  background: inherit;
  border-radius: 1px;
}
.repeat-style-ul .repeat-selected {
  position: absolute;
  display: inline-block;
  width: 24px;
  height: 24px;
  right: 0;
  bottom: 8px;
  z-index: 2;
  background: url("../../assets/images/animate_icon.png") -5px -215px;
  background-size: 280px 244px;
}
/**
平铺样式
 */
/**
对齐方式样式
 */
.align-style-ul {
  width: 54px;
  font-size: 0;
  margin-left: 4px;
}

.align-style-ul > li {
  display: inline-block;
  width: 16px;
  height: 16px;
  opacity: 0.3;
  background: var(--themeColor);
  border-radius: 1px;
  margin: 2px 2px 0 0;
  cursor: pointer;
}

.align-style-ul > li.selected {
  opacity: 1;
}

.font-arrangement-btn {
  flex: 1 1 0%;
}
.font-arrangement-btn span {
  width: calc((100% / 4));
}
.font-arrangement-btn span::before {
  color: #717989;
  font-size: 16px;
}
.fs13 {
  font-size: 13px !important;
}
.tips-btn {
  margin-top: 3px;
}
/**
对齐方式样式
 */
</style>
